<script setup lang="ts">
import type { Product } from '@/types'
import { Head, Link } from '@inertiajs/vue3'
import ProductForm from '@/components/products/ProductForm.vue'
import { dashboardLayout } from '@/lib/layouts'
import { adminProductPath } from '@/routes'

defineOptions({
  layout: dashboardLayout,
})

const props = defineProps<{
  product: Product
}>()

const title = `Edit ${props.product.name}`
</script>

<template>
  <Head :title="title" />

  <UDashboardPanel id="product-edit">
    <template #header>
      <UDashboardNavbar title="Edit product">
        <template #leading>
          <UButton
            :to="adminProductPath(product.slug)"
            :as="Link"
            icon="i-lucide-arrow-left"
            color="neutral"
            variant="ghost"
            square
          />
        </template>
      </UDashboardNavbar>
    </template>

    <template #body>
      <ProductForm
        :product="product"
        :action="adminProductPath(product.slug)"
        method="patch"
        submit-label="Save changes"
      />
    </template>
  </UDashboardPanel>
</template>
